<template>
  <Teleport to="body">
    <Transition name="resultados-gallery-fade">
      <div
        v-if="open && images.length > 0"
        class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/95"
        @click.self="$emit('close')"
      >
        <div
          class="absolute inset-x-0 top-0 z-10 flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4"
        >
          <span class="text-sm font-medium text-white/60 sm:text-base">
            {{ index + 1 }} / {{ images.length }}
          </span>
          <button
            type="button"
            class="rounded-full p-2 text-white/70 transition-colors hover:bg-white/10 hover:text-white"
            aria-label="Cerrar galería"
            @click="$emit('close')"
          >
            <svg class="h-6 w-6 sm:h-7 sm:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="flex w-full flex-1 items-center justify-center px-4 sm:px-12">
          <img
            :src="images[index]"
            :alt="`Imagen ${index + 1}`"
            class="max-h-[75vh] max-w-full rounded-lg object-contain shadow-2xl"
            @click.stop
          />
        </div>

        <div
          v-if="images.length > 1"
          class="pointer-events-none absolute inset-x-0 top-1/2 flex -translate-y-1/2 items-center justify-between px-2 sm:px-4"
        >
          <button
            type="button"
            class="pointer-events-auto flex h-10 w-10 items-center justify-center rounded-full bg-black/40 text-2xl text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:h-12 sm:w-12 sm:text-3xl"
            aria-label="Imagen anterior"
            @click.stop="previous"
          >
            ‹
          </button>
          <button
            type="button"
            class="pointer-events-auto flex h-10 w-10 items-center justify-center rounded-full bg-black/40 text-2xl text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:h-12 sm:w-12 sm:text-3xl"
            aria-label="Imagen siguiente"
            @click.stop="next"
          >
            ›
          </button>
        </div>

        <div v-if="images.length > 1" class="flex gap-2 pb-4 sm:pb-6">
          <button
            v-for="(_, i) in images"
            :key="i"
            type="button"
            class="h-2 rounded-full transition-all duration-200"
            :class="i === index ? 'w-4 bg-white' : 'w-2 bg-white/40 hover:bg-white/60'"
            :aria-label="`Ver imagen ${i + 1}`"
            @click.stop="$emit('update:index', i)"
          />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
const props = defineProps({
  open: { type: Boolean, default: false },
  images: { type: Array, default: () => [] },
  index: { type: Number, default: 0 },
});

const emit = defineEmits(["close", "update:index"]);

function previous() {
  emit("update:index", (props.index - 1 + props.images.length) % props.images.length);
}

function next() {
  emit("update:index", (props.index + 1) % props.images.length);
}
</script>

<style scoped>
.resultados-gallery-fade-enter-active,
.resultados-gallery-fade-leave-active {
  transition: opacity 0.2s ease;
}

.resultados-gallery-fade-enter-from,
.resultados-gallery-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .resultados-gallery-fade-enter-active,
  .resultados-gallery-fade-leave-active {
    transition: none;
  }
}
</style>
